export default "__VITE_ASSET__BqJkvpi___"